import React, { useEffect, useRef } from 'react';
import { useFramePositioning } from '../hooks/useFramePositioning.js';
import { useOnDismiss } from '../hooks/useOnDismiss';
import { cx } from '../utils/cx';
import { RootPortal } from './RootPortal';

function NewDialog({visible, maxHeight, children, onClose}) {
    const dialog = useRef(null);

    useOnDismiss(dialog, visible, onClose);
    const {center} = useFramePositioning(dialog);

    const classNames = cx(
        'overlay fixed inset-0 z-10 overflow-hidden overscroll-contain bg-black/30',
        visible ? 'visible' : 'pointer-events-none opacity-0 invisible',
        maxHeight && 'max-height',
    );

    useEffect(() => {
        if (!visible || dialog.current == null) {
            return;
        }

        function onScroll(e) {
            e.stopPropagation();
        }

        dialog.current.addEventListener('scroll', onScroll, {passive: false});

        return () => {
            if (dialog.current) {
                dialog.current.removeEventListener('scroll', onScroll);
            }
        };
    }, [visible]);

    return (
        <RootPortal>
            <div className={classNames}>
                <div
                    className="dialog flex flex-col overscroll-contain overflow-hidden bg-white rounded-lg fixed left-1/2 -translate-x-1/2 w-[676px] max-w-[calc(90%)] h-[80vh] max-h-[570px]"
                    ref={dialog}
                    style={{
                        top: center,
                    }}
                >
                    {children}
                </div>
            </div>
        </RootPortal>
    );
}

export { NewDialog };
